/**
 * Ferramentas visíveis apenas para usuários cadastrados no core_usuarios.
 * Cadastros (16/17) ficam disponíveis a qualquer usuário autenticado no tenant.
 */
export const PROFILE_REQUIRED_TOOL_IDS = [] as const;

export function hasRegisteredProfile(departamento: string | null | undefined): boolean {
  return Boolean((departamento || '').trim());
}

export function isProfileRequiredTool(tool: { conversionId?: string; id?: string }): boolean {
  if (PROFILE_REQUIRED_TOOL_IDS.length === 0) return false;
  return PROFILE_REQUIRED_TOOL_IDS.includes((tool.id || '') as (typeof PROFILE_REQUIRED_TOOL_IDS)[number]);
}
